import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import debugHelper from '../../admin/utils/debugHelper';
import ImageCropModal from './ImageCropModal';

// Phase 1 i18n — translator.trans() 返回 vnode array，flatten 为 string。
function t(key) {
  const result = app.translator.trans(key);
  return Array.isArray(result) ? result.join('') : result;
}
function tRich(key, params) {
  return app.translator.trans(key, params || {});
}

// 装备类型定义
const EQUIPMENT_TYPES = [{
  key: 'clothing',
  label: () => t('ziven-dress-up.forum.common.equipment_clothing'),
  icon: 'fa-tshirt'
}, {
  key: 'pants',
  label: () => t('ziven-dress-up.forum.common.equipment_pants'),
  icon: 'fa-vest-patches'
}, {
  key: 'helmet',
  label: () => t('ziven-dress-up.forum.common.equipment_helmet'),
  icon: 'fa-hard-hat'
}, {
  key: 'boots',
  label: () => t('ziven-dress-up.forum.common.equipment_boots'),
  icon: 'fa-shoe-prints'
}, {
  key: 'gloves',
  label: () => t('ziven-dress-up.forum.common.equipment_gloves'),
  icon: 'fa-mitten'
}, {
  key: 'goggles',
  label: () => t('ziven-dress-up.forum.common.equipment_goggles'),
  icon: 'fa-glasses'
}, {
  key: 'snowboard',
  label: () => t('ziven-dress-up.forum.common.equipment_snowboard'),
  icon: 'fa-person-skiing'
}, {
  key: 'backpack',
  label: () => t('ziven-dress-up.forum.common.equipment_backpack'),
  icon: 'fa-bag-shopping'
}, {
  key: 'background',
  label: () => t('ziven-dress-up.forum.common.equipment_background'),
  icon: 'fa-image'
}];
export default class EquipmentSelectModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    // selectedEquipments 现在是一个数组，包含已选择的类型
    this.selectedEquipments = this.attrs.selectedEquipments || [];
    // v0.1.1: 上传错误状态（alert 改内联显示用）
    this.uploadError = '';

    // 重选模式：预填充的数据
    this.reselectMode = this.attrs.reselectMode || false;
    this.reselectIndex = this.attrs.reselectIndex !== undefined ? this.attrs.reselectIndex : -1;
    this.reselectData = this.attrs.reselectData || null; // { file, dataUrl, types }

    this.maxFileSize = app.forum.attribute('seedreamMaxFileSize') || 10;

    // 拖拽状态
    this.dragCounter = 0;

    // 已上传的图片和选中的装备类型
    this.uploadedImage = this.reselectMode && this.reselectData ? this.reselectData.file : null;
    this.uploadedPreview = Stream(this.reselectMode && this.reselectData ? this.reselectData.dataUrl : '');
    this.selectedTypes = Stream(this.reselectMode && this.reselectData ? [...this.reselectData.types] : []); // 数组，存储选中的装备类型

    // 文件输入引用
    this.fileInputRef = null;
  }
  className() {
    return 'EquipmentSelectModal Modal--normal';
  }
  title() {
    return this.reselectMode ? t('ziven-dress-up.forum.equipment_select_modal.title_reselect') : t('ziven-dress-up.forum.equipment_select_modal.title_add');
  }

  /**
   * 在重选模式下，显示当前已选择的图片，允许删除
   * 获取可选择的装备列表（重选模式下包含当前选择的类型）
   */
  getAvailableEquipments() {
    if (this.reselectMode && this.reselectData) {
      // 重选模式：显示所有装备类型，当前选中的类型也会显示
      return EQUIPMENT_TYPES;
    }
    // 添加模式：排除已选择的
    return EQUIPMENT_TYPES.filter(item => {
      return !this.selectedEquipments.includes(item.key);
    });
  }

  /**
   * 检查是否可以选择某个装备类型
   */
  canSelectType(type) {
    return true;
  }
  content() {
    const availableEquipments = this.getAvailableEquipments();
    const selected = this.selectedTypes();
    const hasImage = this.uploadedPreview() !== '';
    const canSubmit = hasImage && selected.length > 0;
    return m("div", {
      class: "EquipmentSelectModal-content"
    }, this.uploadError && m("div", {
      class: "error-message"
    }, this.uploadError), m("div", {
      class: "upload-avatar-section"
    }, m("div", {
      class: "upload-avatar-box ".concat(this.dragCounter > 0 ? 'drag-over' : ''),
      onclick: () => this.handleBoxClick(),
      ondragenter: e => this.handleDragEnter(e),
      ondragover: e => this.handleDragOver(e),
      ondragleave: e => this.handleDragLeave(e),
      ondrop: e => this.handleDrop(e)
    }, this.uploadedPreview() ? m("div", {
      class: "avatar-preview-container"
    }, m("img", {
      src: this.uploadedPreview(),
      alt: "Preview"
    }), m("div", {
      class: "preview-overlay",
      onclick: e => {
        e.stopPropagation();
        this.handleBoxClick();
      }
    }, m("i", {
      class: "fas fa-sync-alt"
    }), m("span", null, "\u70B9\u51FB\u66F4\u6362")), this.reselectMode && m("div", {
      class: "preview-delete",
      onclick: e => {
        e.stopPropagation();
        this.deletePreview();
      }
    }, m("i", {
      class: "fas fa-trash-alt"
    }), m("span", null, "\u5220\u9664"))) : m("div", {
      class: "upload-placeholder"
    }, m("i", {
      class: "fas fa-cloud-upload-alt"
    }), m("span", null, "\u70B9\u51FB\u6216\u62D6\u62FD\u4E0A\u4F20\u56FE\u7247"), m("span", {
      class: "upload-hint"
    }, "\u652F\u6301 JPG\u3001PNG \u683C\u5F0F")))), m("input", {
      ref: el => this.fileInputRef = el,
      type: "file",
      accept: "image/jpeg,image/png",
      style: {
        display: 'none'
      },
      onchange: e => this.handleFileSelect(e)
    }), m("div", {
      class: "equipment-type-section"
    }, m("h4", null, m("i", {
      class: "fas fa-tshirt"
    }), t('ziven-dress-up.forum.equipment_select_modal.type_hint')), m("p", {
      class: "section-hint"
    }, tRich('ziven-dress-up.forum.equipment_select_modal.selected_count_inline', {
      count: selected.length,
      total: 9
    })), m("div", {
      class: "EquipmentSelectModal-grid"
    }, availableEquipments.map(item => {
      const isSelected = selected.includes(item.key);
      const canSelect = this.canSelectType(item.key);
      return m("div", {
        class: "equipment-type-card ".concat(isSelected ? 'selected' : '', " ").concat(!canSelect ? 'disabled' : ''),
        key: item.key,
        onclick: () => canSelect && this.toggleType(item.key)
      }, m("div", {
        class: "equipment-icon"
      }, m("i", {
        class: "fas ".concat(item.icon)
      })), m("div", {
        class: "equipment-label"
      }, typeof item.label === 'function' ? item.label() : item.label), isSelected && m("div", {
        class: "selected-check"
      }, m("i", {
        class: "fas fa-check"
      })));
    }))), m("div", {
      class: "EquipmentSelectModal-footer"
    }, m(Button, {
      class: "btn-glass",
      onclick: () => this.onCancel()
    }, m("i", {
      class: "fas fa-times"
    }), t('ziven-dress-up.forum.equipment_select_modal.cancel')), m(Button, {
      class: "btn-amber",
      disabled: !canSubmit,
      onclick: () => this.onSubmit()
    }, m("i", {
      class: "fas fa-plus"
    }), tRich('ziven-dress-up.forum.equipment_select_modal.selected_count_with_add', {
      count: selected.length,
      total: 9
    }))));
  }
  handleDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter++;
    m.redraw();
  }
  handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter < 0) this.dragCounter = 0;
    m.redraw();
  }
  handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter = 0;
    const files = e.dataTransfer.files;
    if (files.length === 0) return;
    const file = files[0];
    this.processFile(file);
  }
  handleBoxClick() {
    // 使用原生DOM方式查找隐藏的file input
    const modal = document.querySelector('.EquipmentSelectModal');
    if (modal) {
      const input = modal.querySelector('input[type="file"]');
      if (input) {
        input.value = ''; // 重置以便选择相同文件
        input.click();
      }
    }
  }
  triggerFileSelect() {
    this.handleBoxClick();
  }
  handleFileSelect(e) {
    const file = e.target.files[0];
    if (!file) return;
    this.processFile(file);
  }
  processFile(file) {
    // 验证文件类型
    const allowedTypes = ['image/jpeg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      this.uploadError = t('ziven-dress-up.forum.common.invalid_type');
      m.redraw();
      return;
    }

    // 验证文件大小
    if (file.size > this.maxFileSize * 1024 * 1024) {
      this.uploadError = tRich('ziven-dress-up.forum.common.file_too_large', {
        size: this.maxFileSize
      });
      m.redraw();
      return;
    }
    const self = this;
    const reader = new FileReader();
    reader.onload = function (event) {
      const dataUrl = event.target.result;
      if (!dataUrl || typeof dataUrl !== 'string' || !dataUrl.startsWith('data:')) {
        self.uploadError = t('ziven-dress-up.forum.common.read_error');
        m.redraw();
        return;
      }

      // 验证 magic bytes
      const base64Data = dataUrl.split(',')[1];
      if (!base64Data) {
        self.uploadError = t('ziven-dress-up.forum.common.invalid_format');
        m.redraw();
        return;
      }
      try {
        const binaryString = atob(base64Data.substring(0, 24));
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const isValidImage = self.validateImageMagicBytes(bytes, file.type);
        if (!isValidImage) {
          self.uploadError = t('ziven-dress-up.forum.common.invalid_content');
          m.redraw();
          return;
        }
      } catch (err) {
        self.uploadError = t('ziven-dress-up.forum.common.invalid_content_short');
        m.redraw();
        return;
      }
      self.uploadedImage = file;
      self.uploadedPreview(dataUrl);
      m.redraw();

      // v0.4.7 #365 — 上传后弹剪裁 modal (开关 ON 时)
      // stackModal=true 叠在 EquipmentSelectModal 上方 (默认会替换)
      if (typeof localStorage !== 'undefined' && localStorage.getItem('seedream.cropEnabled') !== 'false') {
        app.modal.show(ImageCropModal, {
          imageDataUrl: dataUrl,
          onConfirm: (croppedBlob, croppedDataUrl) => {
            // 剪裁完成 — 用剪裁后的 blob/dataUrl 替换
            self.uploadedImage = croppedBlob;
            self.uploadedPreview(croppedDataUrl);
            self.uploadError = '';
            m.redraw();
          },
          onCancel: () => {
            // 辉哥 22:23 亲测 bug — 取消剪裁应该回到空的上传框 (清空 uploadedImage/uploadedPreview)
            // v0.4.7 #365 原 onCancel 是空实现导致图片仍显示 — 修正
            self.uploadedImage = null;
            self.uploadedPreview('');
            self.uploadError = '';
            m.redraw();
          }
        }, true); // stackModal=true 叠在 EquipmentSelectModal 上
      }
    };
    reader.onerror = function () {
      self.uploadError = t('ziven-dress-up.forum.common.read_error');
      m.redraw();
    };
    reader.readAsDataURL(file);
  }

  /**
   * 切换装备类型选择
   */
  toggleType(type) {
    const selected = this.selectedTypes();
    const index = selected.indexOf(type);
    if (index >= 0) {
      // 取消选择
      selected.splice(index, 1);
    } else {
      // 添加选择
      selected.push(type);
    }
    this.selectedTypes([...selected]);
    m.redraw();
  }

  /**
   * 取消关闭
   */
  onCancel() {
    app.modal.close();
  }

  /**
   * 确认添加
   */
  onSubmit() {
    if (!this.uploadedImage || this.selectedTypes().length === 0) {
      return;
    }

    // 调用回调函数，传递装备数据
    if (this.attrs.onSubmit) {
      this.attrs.onSubmit(this.uploadedImage,
      // 原始File对象
      this.uploadedPreview(),
      // 本地预览URL
      [...this.selectedTypes()], this.reselectMode ? this.reselectIndex : -1 // 重选模式下传递索引
      );
    }
    app.modal.close();
  }

  /**
   * 删除预览图片（重选模式下）
   */
  deletePreview() {
    this.uploadedImage = null;
    this.uploadedPreview('');
    this.selectedTypes([]);
    m.redraw();
  }

  /**
   * 验证图片文件的 magic bytes
   */
  validateImageMagicBytes(uint8Array, mimeType) {
    if (uint8Array.length < 4) {
      return false;
    }
    const JPEG_MAGIC = [0xFF, 0xD8, 0xFF];
    const PNG_MAGIC = [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A];
    if (mimeType === 'image/jpeg') {
      let isJpeg = true;
      for (let i = 0; i < JPEG_MAGIC.length; i++) {
        if (uint8Array[i] !== JPEG_MAGIC[i]) {
          isJpeg = false;
          break;
        }
      }
      if (isJpeg) return true;
    }
    if (mimeType === 'image/png') {
      let isPng = true;
      for (let i = 0; i < PNG_MAGIC.length; i++) {
        if (uint8Array[i] !== PNG_MAGIC[i]) {
          isPng = false;
          break;
        }
      }
      if (isPng) return true;
    }
    return false;
  }
}
_defineProperty(EquipmentSelectModal, "isDismissibleViaBackdropClick", false);
_defineProperty(EquipmentSelectModal, "isDismissibleViaCloseButton", true);
flarum.reg.add('ziiven-dress-up', 'forum/components/EquipmentSelectModal', EquipmentSelectModal);